<template>
  <div>
    <Head title="Manufacturing Receipts" />
    <h1 class="mb-8 text-3xl font-bold">Manufacturing Receipts</h1>
    <div class="bg-white rounded-md shadow overflow-hidden mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pr-8 pl-8 pb-8">
          <select-input
            v-model="form.location"
            :error="form.errors.location"
            class="pb-2 pr-6 w-full lg:w-1/2"
          >
            <option :value="null">
              Select the location
            </option>
            <option
              v-for="location in locations"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select-input>

          <text-input
            v-model="form.item_id"
            :error="form.errors.item_id"
            class="pb-2 pr-6 justify-end w-full lg:w-1/2"
            placeholder="Scan UID"
          />
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Receipts
          </loading-button>
        </div>
      </form>
    </div>


    <div class="flex items-center justify-between mb-6 mt-6 hidden">
      <Link class="btn-orange" href="">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;Receipt</span>
      </Link>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Today's Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">All Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-summaryFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-summary-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false">Summaries</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3">Quantity</th>
              <th class="pb-3 pt-2 px-3">Adj. Quantity</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3" colspan="2">UoM</th>
            </tr>
            <tr v-for="item in receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.adjusted_quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.measure }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link v-show="item.measure !== 'PCS' || item.measure !=='PC' || item.measure !== 'PKT' || item.measure !== 'PKTS'" class="flex items-center px-4" :href="`/manufacturing-receipts/${item.id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="receipts.data.length === 0">
              <td class="px-2 py-2 border-t" colspan="10">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="receipts.links" />
      </div>
      <div class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3"  @reset="reset"/>
          <a
            v-if="manufacturing_receipts.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/manufacturing/receipts/download/${search.dateValue}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3">Quantity</th>
              <th class="pb-3 pt-2 px-3">Adj. Quantity</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3" colspan="2">UoM</th>
            </tr>
            <tr v-for="manufacturing_receipt in manufacturing_receipts.data" :key="manufacturing_receipt.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ manufacturing_receipt.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.adjusted_quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ manufacturing_receipt.measure }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link v-show="manufacturing_receipt.measure !== 'PCS' || manufacturing_receipt.measure !=='PC' || manufacturing_receipt.measure !== 'PKT' || manufacturing_receipt.measure !== 'PKTS'" class="flex items-center px-4" :href="`/manufacturing-receipts/${manufacturing_receipt.id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="manufacturing_receipts.data.length === 0">
              <td class="px-2 py-2 border-t" colspan="10">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="manufacturing_receipts.links" />
      </div>
      <div class="tab-pane fade" id="tabs-summaryFill" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="summary.dateRange" class="mr-0 w-full max-w-md" @reset="resets"/>
          <a
            v-if="manufacturing_receipt_summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/manufacturing/receipts/summaries/download/${summary.dateRange}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Part Description</th>
              <th class="pb-2 pt-2 px-3">Category</th>
              <th class="pb-2 pt-2 px-3">Count</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
            </tr>
            <tr
              v-for="manufacturing_receipt_summary in manufacturing_receipt_summaries.data"
              :key="manufacturing_receipt_summary.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ manufacturing_receipt_summary.sku_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ manufacturing_receipt_summary.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ manufacturing_receipt_summary.category }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ manufacturing_receipt_summary.total }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ manufacturing_receipt_summary.quantity }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ manufacturing_receipt_summary.unit_of_measure }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ manufacturing_receipt_summary.location }}
                </span>
              </td>
            </tr>
            <tr v-if="manufacturing_receipt_summaries.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="manufacturing_receipt_summaries.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DateRange from '@/Shared/DateRange'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    receipts: Object,
    locations: Object,
    manufacturing_receipts: Object,
    manufacturing_receipt_summaries: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
        quantity: null,
        adjusted_quantity: null,
        location: null,
      }),
      measurePcs: ['PCS', 'PC'],
      itemObj: [],
      msgStr: '',
      hasQuantity: false,
      hasReceipt: false,
      search: {
        dateValue: this.filters.dateValue
      },
      summary: {
        dateRange: this.filters.dateRange
      }
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/manufacturing-receipts/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summary: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/manufacturing-receipts/', pickBy(this.summary), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    confirmItem() {
      return this.itemObj || []
    },
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  methods: {
    addQuantity() {
      this.hasReceipt = true
      this.hasQuantity = true
    },
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    resets() {
      this.summary = mapValues(this.summary, () => null)
    },
    store() {
      this.form.post('/manufacturing-receipts', {
        onSuccess: () => {
          this.form.item_id = ''
          this.form.quantity = ''
          this.form.adjusted_quantity = ''
          this.itemObj = []
          this.hasReceipt = false
          this.hasQuantity = false
        },
      })        
    },
    checkUID() {
      this.msgStr = ''
      if (this.form.item_id) {
        axios.get(`/inventory-manufacturing-receipt-items/${this.form.item_id}/search`).then(response => {
          if (response.data.message === '') {
            this.itemObj = response.data
            this.msgStr = ''
            this.form.quantity = response.data.quantity
          } else {
            this.itemObj = []
            this.msgStr = response.data.message
          }
        })
      } else {
        this.msgStr = ''
      }
    },
  },
}
</script>
